/**
 * "O que o pórtico leu", ao lado da nossa leitura (`SC-06a`, ADR-095).
 *
 * Mora no Visor, logo abaixo das fotos: é onde o operador olha a placa. Só aparece quando o
 * pórtico mandou leitura — o pórtico emulado e, depois, o da Tecsidel (`SC-08`); a passagem
 * de outro caminho não ganha um cartão vazio. Não há botão aqui: a comparação informa, e a
 * aprovação continua sendo da pessoa (ADR-008).
 */
import { Badge } from "../componentes/base";
import type { DetalheDoTransito } from "../api/tipos";
import { comparacaoDoPortico, corDaSituacao, textoDaSituacao } from "./portico";

export function LeituraDoPortico({ detalhe }: { detalhe: DetalheDoTransito }) {
  const comparacao = comparacaoDoPortico(detalhe);
  if (!comparacao) return null;
  return (
    <section
      aria-label="Leitura do pórtico"
      className="grid gap-1.5 rounded-cartao border border-linha bg-painel-2 p-2"
    >
      <header className="flex items-center justify-between gap-2">
        <span className="text-[9.5px] tracking-[0.06em] text-tinta-2 uppercase">
          Pórtico × nossa leitura
        </span>
        <Badge cor={comparacao.resumo.cor}>{comparacao.resumo.texto}</Badge>
      </header>
      <table className="w-full text-[11.5px]">
        <thead>
          <tr className="text-left text-[9.5px] tracking-[0.06em] text-tinta-3 uppercase">
            <th className="py-0.5 font-normal" />
            <th className="py-0.5 font-normal">Nossa visão</th>
            <th className="py-0.5 font-normal">Pórtico</th>
            <th className="py-0.5 font-normal" />
          </tr>
        </thead>
        <tbody>
          {comparacao.linhas.map((l) => (
            <tr key={l.chave} className="border-t border-linha">
              <th
                scope="row"
                className="py-1 pr-2 text-left font-normal text-tinta-2"
              >
                {l.rotulo}
              </th>
              <td className="mono py-1 pr-2">{l.nossa}</td>
              <td className="mono py-1 pr-2">{l.portico}</td>
              <td className="py-1 text-right">
                {l.situacao && (
                  <Badge cor={corDaSituacao(l.situacao)}>
                    {textoDaSituacao(l.situacao)}
                  </Badge>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
